<template>
  <v-row no-gutters class="pl-10 align-baseline py-2">
    <v-col class="text-left" cols="3">
      <div class="font-weight-normal text-16 font--text" style="line-height: 16px">{{ setting.translation }}:</div>
      <div class="font-italic font-weight-light" style="font-size: 12px">{{ setting.subtitle }}</div>
      <div class="font-italic font-weight-light" style="font-size: 12px; line-height: normal">
        {{ setting.explanation }}
      </div>
    </v-col>
    <v-col cols="3">
      <data-input
        :data-type="setting.dataType"
        :items="setting.selectItems"
        item-text="name"
        item-value="value"
        v-bind="setting.dataInputProps"
        v-model="computedValue"
        :return-object="false"
      />
    </v-col>
  </v-row>
</template>

<script>
import DataInput from '@/components/DataInput';

export default {
  name: 'ModelingOptionsRow',
  components: { DataInput },
  props: {
    setting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.setting.value;
      },
      set(nV) {
        this.$emit('input', {
          settingName: this.setting.setting,
          newValue: nV,
        });
      },
    },
  },
};
</script>
